import { FolderDialog } from "./folder-dialog";
import { useFolderMutations } from "../hooks/use-folder-mutations";
import { useTaskMutations } from "../hooks/use-task-mutations";
import { useSidebarContext } from "../sidebar-context";

export const SidebarDialogs = () => {
  const { folderDialogState, closeFolderDialog } = useSidebarContext();
  const { createFolder, renameFolder } = useFolderMutations();
  const { renameTask } = useTaskMutations();

  const isSubmitting = createFolder.isPending || renameFolder.isPending || renameTask.isPending;

  const handleSubmit = (values: { name: string }) => {
    const { mode, brandId, parentFolderId, folderId, taskId } = folderDialogState;
    if (mode !== "rename-task" && !brandId) return;

    if (mode === "create") {
      createFolder.mutate(
        {
          brandId: brandId!,
          name: values.name,
          parentFolderId: parentFolderId,
        },
        {
          onSuccess: () => {
            closeFolderDialog();
          },
        }
      );
    } else if (mode === "rename" && folderId) {
      renameFolder.mutate(
        {
          brandId: brandId!,
          folderId,
          name: values.name,
        },
        {
          onSuccess: () => {
            closeFolderDialog();
          },
        }
      );
    } else if (mode === "rename-task" && taskId) {
      renameTask.mutate(
        {
          taskId,
          name: values.name,
        },
        {
          onSuccess: () => closeFolderDialog(),
        }
      );
    }
  };

  const defaultName =
    folderDialogState.mode === "rename-task"
      ? folderDialogState.taskName
      : folderDialogState.folderName;

  return (
    <FolderDialog
      isOpen={folderDialogState.isOpen}
      mode={folderDialogState.mode}
      defaultName={defaultName}
      onClose={closeFolderDialog}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
};
